export const SESSION_KICKED_CODE = "SESSION_KICKED";

export const SESSION_KICKED_MESSAGE =
  "您已被挤下线，如非本人操作，请及时修改密码。";

export function resolveSessionKickedMessage(
  message?: string | null,
  localizedDefault = SESSION_KICKED_MESSAGE,
) {
  const trimmed = message?.trim();

  return trimmed && trimmed !== SESSION_KICKED_MESSAGE ? trimmed : localizedDefault;
}
